import { tokens } from "../../theme/tokens";

// react-select renders its own DOM, so its look is set through this styles
// object rather than a class. Every value is a token, so the wizard's selects
// match its inputs (style guide §9): 40px, radius.sm, border.default, brand
// focus ring, no shadow.
export const reactSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: tokens.density.field,
    backgroundColor: tokens.color.surface.default,
    borderColor: state.isFocused
      ? tokens.color.focus.ring
      : tokens.color.border.default,
    borderRadius: tokens.radius.sm,
    boxShadow: "none",
    fontSize: tokens.type.dense.size,
    "&:hover": { borderColor: tokens.color.border.strong },
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 20,
    fontSize: tokens.type.dense.size,
    borderRadius: tokens.radius.sm,
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? tokens.color.brand.primaryAction
      : state.isFocused
      ? tokens.color.surface.hover
      : tokens.color.surface.default,
    color: state.isSelected
      ? tokens.color.brand.onPrimary
      : tokens.color.text.primary,
  }),
  singleValue: (base: any) => ({ ...base, color: tokens.color.text.primary }),
  placeholder: (base: any) => ({ ...base, color: tokens.color.text.secondary }),
  input: (base: any) => ({ ...base, color: tokens.color.text.primary }),
};
